
import { Vue, Options, Prop } from 'vue-property-decorator';

import Nomination from '@/service/nomination';
import { umi } from '@/service/umi';

import MaterialIcon from '@/components/material/Icon.vue';
import DetailsMap from './Map.vue';

import locales from './Info.locales.json';

@Options({
    components: {
        MaterialIcon,
        DetailsMap,
    },
    i18n: {
        messages: locales
    }
})
export default class NominationDetails extends Vue {

    @Prop(Nomination) readonly nomination!: Nomination;

    get confirmedTime(): string {
        return new Date(this.nomination.confirmedTime).toLocaleDateString();
    }

    get resultTime(): string {
        if (this.nomination.status === umi.StatusCode.Pending) return '';
        return new Date(this.nomination.resultTime).toLocaleDateString();
    }

    get rejected(): boolean {
        return this.nomination.status === umi.StatusCode.Rejected;
    }

    get reasons(): Array<umi.Reason> {
        if (!this.rejected) return [];
        if (this.nomination.reasons.length < 1) return [ umi.reason.get(umi.Reason.undeclared)! ];
        return this.nomination.reasonsData;
    }
}
